import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { SenaceService } from 'src/app/services/senace.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tab-participacion-ciudadana',
  templateUrl: './tab-participacion-ciudadana.component.html',
  styleUrls: ['./tab-participacion-ciudadana.component.css']
})
export class TabParticipacionCiudadanaComponent implements OnInit {
  @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;
  participacion: number;

  tipoDocumento = '1';
  adjuntarDocumento = false;
  expedienteId?: string;
  nroExpediente?: string;

  fecini?: string;
  fecfin?: string;
  idExpediente: number;  

  // cargando?: boolean;
  pesoMaximo = 20000000; // 20 Mb
  maxLength = 8;

  formulario: FormGroup;
  formularioBusqueda: FormGroup;

  sexo = [
    { valor: '', texto: '-- Seleccione --' },
    { valor: '1', texto: 'Hombre' },
    { valor: '2', texto: 'Mujer' },
  ];

  sustento = "";
  observacion = "";

  file: File | null = null;

  readonlyPersona = "readonly";

  constructor(
    private modal: NgbModal,
    private serviceSenace: SenaceService,
    private formBuilder: FormBuilder,
    private localStorage: LocalStorage
  ) {
    this.localStorage.getItem('detalle').subscribe(
      (resp: any) => {
        this.participacion = resp.participacion;
      }
    )

    this.iniciarFormulario();
  }

  ngOnInit() {    
    this.localStorage.getItem('detalle').subscribe(
      resp => {
        this.nroExpediente = resp['correlativo'];
        this.expedienteId = resp['expedienteId'];
        this.fecini = resp['fechainivigencia'];
        this.fecfin = resp['fechafinvigencia'];
        this.idExpediente = resp['expedienteId'];

      }
    ) 
  }
  iniciarFormulario() {
    this.formulario = this.formBuilder.group(
      {
        tipodocumento: ['1', [Validators.required]],
        nrodocumento: ['', [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
        correo: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]],
        //sustento: ['', [Validators.required, Validators.maxLength(1000)]],
        observacion: ['', [Validators.required, Validators.maxLength(2000)]],

        nombres: ['', [Validators.required]],
        apellidos: ['', [Validators.required]],
        sexo: ['', [Validators.required]],
        razonsocial: ['', []],
        file: [null]
      }
    );

    const nombres = this.formulario.get('nombres');
    const apellidos = this.formulario.get('apellidos');
    const sexo = this.formulario.get('sexo');
    const razonsocial = this.formulario.get('razonsocial');    

    this.formulario.get('tipodocumento').valueChanges.subscribe(
      resp => {
        if (resp === '1') { // PERSONA
          razonsocial.clearValidators();
          razonsocial.updateValueAndValidity();

          nombres.setValidators([Validators.required]);
          apellidos.setValidators([Validators.required]);
          sexo.setValidators([Validators.required]);
          this.maxLength = 8;
          this.desactivarEdicionDni();
        } if (resp === '2') { // RAZON SOCIAL
          nombres.clearValidators();
          nombres.updateValueAndValidity();
          apellidos.clearValidators();
          apellidos.updateValueAndValidity();
          sexo.clearValidators();
          sexo.updateValueAndValidity();
          razonsocial.setValidators([Validators.required]);
          this.maxLength = 11;
        }
        this.formulario.get('nrodocumento').setValue("");
      }
    );
  }
  uploadFile(event) {
    this.file = <File>(event.target as HTMLInputElement).files[0];

    if (this.pesoMaximo < this.file.size) {
      event.srcElement.value = null;
      Swal.fire({
        title: 'Aviso',
        text: 'El archivo seleccionado excede los 20mb permitidos. Intente seleccionar otro.',
        icon: 'warning',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    this.formulario.patchValue({
      file: this.file
    });
    this.formulario.get('file').updateValueAndValidity()
  }

  limpiarFormulario() {
    this.formulario.patchValue({
      file: null
    });
    if (this.fileUpload) {
      this.fileUpload.nativeElement.value = '';
    }

    this.formulario.markAsPristine();
    this.formulario.markAsUntouched();
    this.formulario.reset();
    this.iniciarFormulario();
  }

  enviar() {
    if (this.formulario.invalid) {
      Swal.fire({
        title: 'Aviso',
        text: 'Verifique los campos obligatorios *',
        icon: 'warning',
        confirmButtonText: 'Aceptar'
      });
      return Object.values(this.formulario.controls).forEach(
        (control) => {
          if (control instanceof FormGroup) {
            Object.values(control.controls).forEach(
              control => {
                control.markAsTouched();
              }
            )
          } else {
            control.markAsTouched();
          }
        }
      )
      return;
    }

    Swal.fire({
      title: '',
      text: 'Enviando los datos del formulario ...',
      allowOutsideClick: false,
      showConfirmButton: false
    });
    Swal.showLoading();

    let data: any = {};
    const formData = new FormData();
    var nombreDoc: string = '';  
    var idSexo: number = 0;      

    data.tipoPersona = this.formulario.get('tipodocumento').value;
    data.nroDocumento = this.formulario.get('nrodocumento').value;
    data.nombreCompleto = `${this.formulario.get('nombres').value} ${this.formulario.get('apellidos').value}`;

    if (data.tipoPersona === '2') {
      data.nombreCompleto = this.formulario.get('razonsocial').value;    
      idSexo = 1;  
    }
    else {
      data.sexo = this.formulario.get('sexo').value;
      idSexo = data.sexo;
    }
    //data.sustento = this.formulario.get('sustento').value;
    data.sustento = "SIN SUSTENTO";
    data.observacion = this.formulario.get('observacion').value;
    data.correo = this.formulario.get('correo').value;
    data.Expediente = this.nroExpediente;
    data.expedienteId = this.expedienteId;

    
    // Agregar documento SOLO si existe
    if (this.file) {
       nombreDoc = this.file.name;
    }
    else {
       nombreDoc = "-";       
    }
    
    formData.append('action', 'WS_AC_APORTE_ALFRESCO');

    const metadata = {
        metaData: [
            {
            idExpediente: data.expedienteId,
            tipoPersona: Number(data.tipoPersona),
            tipoIdentificacion: Number(data.tipoPersona),
            identificacion: data.nroDocumento,
            nombreRazon: data.nombreCompleto,
            sexo: idSexo,
            email: data.correo,
            sustento: "",
            observacion: data.observacion,
            descripcionAdjunto: nombreDoc,
            nroContacto:""
            }
        ]
    };
      
    formData.append('metaData', JSON.stringify(metadata));    

    if (this.file) {
      formData.append('documento',this.file, this.file.name); 
    }

    this.serviceSenace.enviarFormulario(formData).subscribe(
        (response) => {
          Swal.fire({
            title: 'Aviso',
            text: 'Se ha registrado la información del formulario.',
            icon: 'success',
            confirmButtonText: 'Aceptar'
          });
          // Limpiar formulario....
          this.limpiarFormulario();
          this.desactivarEdicionDni();
      },
      (error) => {
        Swal.fire({
          title: 'Aviso',
          text: 'Error al registrar los datos del formulario. Intente nuevamente.',
          icon: 'warning',
          confirmButtonText: 'Aceptar'
        });
      });   
    /*
    // Enviar datos ...
    this.serviceSenace.enviarFormulario(data)
      .subscribe(
        (response) => {

          //if (this.formulario.get('file').value !== null && this.sustento.length > 0 && this.observacion.length > 0) {
            if (this.formulario.get('file').value !== null && this.observacion.length > 0) {
            const formData = new FormData();
            formData.append("file", this.formulario.get('file').value);

            // Enviar datos para subir documento ...
            const params = {
              idAc: response.Result.IdAC,
              idAcOb: response.Result.IdAcObs,
              idExp: this.expedienteId,
              sustento: response.Result.Observacion,
              expediente: response.Result.Expediente
            }
            this.serviceSenace.subirDocumento(formData, params)
              .subscribe(
                (response: any) => {
                  Swal.fire({
                    title: 'Aviso',
                    text: 'Se ha registrado la información del formulario.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                  });
                  // Limpiar formulario....
                  this.limpiarFormulario();
                  this.desactivarEdicionDni();
                },
                (error) => {
                  Swal.fire({
                    title: 'Aviso',
                    text: 'Error al cargar el documento. Intente nuevamente.',
                    icon: 'warning',
                    confirmButtonText: 'Aceptar'
                  });
                },
              )

          } else {
            Swal.fire({
              title: 'Aviso',
              text: 'Se ha registrado la información del formulario.',
              icon: 'success',
              confirmButtonText: 'Aceptar'
            });
            // Limpiar formulario....
            this.limpiarFormulario();
            this.desactivarEdicionDni();
          }
        },
        (error) => {
          Swal.fire({
            title: 'Aviso',
            text: 'Error al registrar los datos del formulario. Intente nuevamente.',
            icon: 'warning',
            confirmButtonText: 'Aceptar'
          });
        }
      )
    */
  }


  consultarDni() {
    if (!this.validarDni(this.formulario.value.nrodocumento)) {
      Swal.fire({
        title: 'Aviso',
        text: 'Ingrese un DNI válido',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    // this.cargando = true;
    Swal.fire('','Consultando documento ...','info');
    Swal.showLoading();
    this.serviceSenace.getConsultarDni(this.formulario.value.nrodocumento)
      .subscribe(
        (response) => {
          // this.cargando = false;
          Swal.close();
          if (response.nombres === '' || response.apellidos === '') {
            Swal.fire({
              title: 'Aviso',
              text: response.info,
              icon: 'warning',
              confirmButtonText: 'Aceptar'
            });
            this.formulario.patchValue({ nombres: '', apellidos: '' });
            return;
          } else {
            this.formulario.patchValue({
              nombres: response.nombres,
              apellidos: response.apellidos,
            });
          }
        },
        (error) => {
          // this.cargando = false;
          this.activarEdicionDni();
          Swal.fire({
            title: `Código error: ${error.status}`,
            text: `Error al consultar el DNI. Ingrese sus nombres y apellidos.`,
            icon: 'warning',
            confirmButtonText: 'Aceptar'
          });
        }
      );
  }

  activarEdicionDni() {
    this.readonlyPersona = "";
    this.formulario.patchValue({
      nombres: '',
      apellidos: ''
    })
  }

  desactivarEdicionDni() {
    this.readonlyPersona = "readonly";
    this.formulario.patchValue({
      nombres: '',
      apellidos: ''
    })
  }

  consultarRuc() {
    if (!this.validarRuc(this.formulario.value.nrodocumento)) {
      Swal.fire({
        title: 'Aviso',
        text: 'Ingrese un RUC válido',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    // this.cargando = true;
    Swal.fire('','Consultando documento ...','info');
    Swal.showLoading();
    this.serviceSenace.getConsultarRuc(this.formulario.value.nrodocumento)
      .subscribe(
        (response) => {
          // this.cargando = false;
          Swal.close();
          this.formulario.patchValue({
            razonsocial: response.razonSocial
          });

          if (!response.razonSocial) {
            Swal.fire({
              title: 'Aviso',
              text: 'No hay información en Razón Social . Verifique el Nro de RUC ingresado.',
              icon: 'warning',
              confirmButtonText: 'Aceptar'
            });
          }


        },
        (error) => {
          // this.cargando = false;
          Swal.fire({
            title: 'Aviso',
            text: 'Error al consultar el RUC. Intente nuevamente',
            icon: 'warning',
            confirmButtonText: 'Aceptar'
          });
        }
      )
  }

  consultarServicio() {
    // Persona natural ...
    if (this.formulario.value.tipodocumento === '1') {
      this.consultarDni();
      // Persona juridica ...
    } else if (this.formulario.value.tipodocumento === '2') {
      this.consultarRuc();
    }
  }

  validarDni(s: string) {
    return /^\d{8}(?:[-\s]\d{4})?$/.test(s)
  }

  validarRuc(ruc?: any) {
    return (this.esNumero(ruc) && (ruc.length === 11));
  }

  esNumero(ruc) {
    return (ruc = Number(ruc)) && ruc % 1 === 0
  }

  // Validaciones....
  get validarDocumento() {
    return this.formulario.get('nrodocumento').invalid && this.formulario.get('nrodocumento').touched;
  }

  get validarCorreo() {
    return this.formulario.get('correo').invalid && this.formulario.get('correo').touched;
  }

  get validarNombre() {
    return this.formulario.get('nombres').invalid && this.formulario.get('nombres').touched;
  }

  get validarApellido() {
    return this.formulario.get('apellidos').invalid && this.formulario.get('apellidos').touched;
  }
  get validarSexo() {
    return this.formulario.get('sexo').invalid && this.formulario.get('sexo').touched;
  }
  get validarSustento() {
    return this.formulario.get('sustento').invalid && this.formulario.get('sustento').touched;
  }
  get validarObservacion() {
    return this.formulario.get('observacion').invalid && this.formulario.get('observacion').touched;
  }
  get validarRazonSocial() {
    return this.formulario.get('razonsocial').invalid && this.formulario.get('razonsocial').touched;
  }

}
